import { render } from "./AccountPopover.vue?vue&type=template&id=89909ba4"
import script from "./AccountPopover.vue?vue&type=script&lang=js"
export * from "./AccountPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__